import { Activity, Database } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getIntlLocale } from '$lib/i18n';

export interface StatusBarProps {
  rowCount?: number;
  filteredCount?: number;
  lastSync?: string | null;
}

// Bottom strip surfaces the analyst's at-a-glance state: filtered/total
// counts, last data sync. Stays consistent with the "no friendly noise" rule —
// nothing here interrupts work, only reflects state.
export function StatusBar({ rowCount, filteredCount, lastSync }: StatusBarProps) {
  const { t } = useTranslation();
  const tag = getIntlLocale();
  return (
    <footer
      data-testid="status-bar"
      className="flex h-7 shrink-0 items-center gap-4 border-t border-rule bg-surface px-3 text-2xs text-fg-muted"
    >
      <span className="flex items-center gap-1.5">
        <Database size={12} />
        <span className="num text-fg">{rowCount?.toLocaleString(tag) ?? '—'}</span>
        <span>{t('statusBar.unitsTotal')}</span>
        {typeof filteredCount === 'number' && (
          <>
            <span className="text-fg-subtle">·</span>
            <span className="num text-fg">{filteredCount.toLocaleString(tag)}</span>
            <span>{t('statusBar.matchFilters')}</span>
          </>
        )}
      </span>
      <span className="ml-auto flex items-center gap-1.5">
        <Activity size={12} />
        <span>{t('statusBar.lastSync')}</span>
        <span className="num text-fg">{lastSync ?? '—'}</span>
      </span>
    </footer>
  );
}
